import React from 'react';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import SecurityIcon from '@material-ui/icons/Security';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function Footer(props) {
  const { classes } = props;
  return (
    <div className={classes.footer}>
      {footerLinks.map((link, index) => (
        <span key={index} className={classes.footerItem}>
          <a
            href={link.url}
            rel="noopener"
            target={`${link.openInSameWindow ? '_self' : '_blank'}`}
          >
            {link.title}
          </a>
        </span>
      ))}
    </div>
  );
}

export default withStyles(styles)(Footer);
